import React from "react";
import Fade  from "react-reveal/Fade";
const EarnReturn = () => {
  return (
    <svg
      width="30"
      height="18"
      viewBox="0 0 30 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0082 17.2497C10.7797 17.2497 6.55127 17.2497 2.32279 17.2497C1.07767 17.2497 0.4843 16.6841 0.483613 15.4874C0.480179 10.9861 0.479492 6.48475 0.479492 1.9834C0.479492 0.838071 1.09347 0.249084 2.28296 0.249084C10.7742 0.249084 19.2655 0.249084 27.7568 0.249084C28.9449 0.249084 29.5465 0.837405 29.5465 1.99272C29.5465 6.43877 29.5465 10.8848 29.5465 15.3302C29.5465 15.4301 29.5465 15.5301 29.5452 15.6294C29.5273 16.6308 28.9003 17.2417 27.8653 17.2471C26.4251 17.2544 24.9857 17.2491 23.5455 17.2491C20.7002 17.2491 17.8542 17.2491 15.0089 17.2491L15.0082 17.2497ZM18.6261 14.2462C18.758 14.2568 18.7992 14.2628 18.8411 14.2628C20.4399 14.2628 22.0394 14.2682 23.6382 14.2535C23.7557 14.2522 23.9219 14.1316 23.9809 14.0236C24.5015 13.0742 25.2391 12.342 26.2322 11.8642C26.4313 11.7683 26.4753 11.6517 26.4746 11.4525C26.467 9.64622 26.467 7.83995 26.4746 6.03368C26.4753 5.8338 26.4265 5.71853 26.2287 5.62325C25.2357 5.14487 24.4891 4.4153 23.996 3.45253C23.9026 3.26997 23.7845 3.23066 23.5949 3.23133C22.0641 3.23666 20.534 3.23466 19.0032 3.23466C18.907 3.23466 18.8102 3.23466 18.714 3.23466C20.6281 4.62717 21.7056 6.42678 21.7063 8.74075C21.7063 11.0554 20.6473 12.865 18.6261 14.2455V14.2462ZM11.3896 3.23533C9.66235 3.23533 8.01822 3.23133 6.37408 3.24465C6.26557 3.24532 6.11242 3.36192 6.05679 3.46386C5.53965 4.4153 4.80274 5.14887 3.81035 5.62925C3.61599 5.72319 3.5583 5.83313 3.55968 6.03634C3.56792 7.84328 3.56723 9.65022 3.55968 11.4572C3.55899 11.6577 3.60912 11.7723 3.80623 11.8669C4.78763 12.3413 5.52935 13.0615 6.02382 14.0096C6.12959 14.2122 6.25389 14.2655 6.47366 14.2635C8.00448 14.2535 9.5353 14.2562 11.0668 14.2535C11.1499 14.2535 11.233 14.2388 11.3518 14.2269C7.38844 11.6564 7.23735 5.93374 11.3896 3.23399V3.23533ZM19.1934 8.77273C19.2181 6.58136 17.357 4.73311 15.0934 4.70246C12.7865 4.67115 10.8663 6.47608 10.8443 8.69678C10.8223 10.9621 12.6897 12.7884 15.0487 12.8064C17.2752 12.8237 19.1687 10.9814 19.1934 8.7734V8.77273Z"
        fill="#E21F27"
      />
    </svg>
  );
};

const Automate = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8372 3.18343e-06C19.9271 0.00491202 25.6824 5.70714 25.6657 12.7108C25.6483 19.7151 19.9023 25.3879 12.8285 25.383C5.74047 25.3787 -0.0173335 19.6728 3.921e-05 12.6716C0.0174119 5.66787 5.76404 -0.00490566 12.8372 3.18343e-06ZM3.66319 12.6826C3.65823 17.6724 7.7619 21.7462 12.8087 21.7609C17.8666 21.7756 21.9976 17.7043 22.0032 12.7004C22.0087 7.70933 17.9063 3.63745 12.8577 3.62273C7.80161 3.608 3.66816 7.6805 3.66319 12.6826Z"
        fill="#E21F27"
      />
      <path
        d="M10.9967 10.8835C10.9967 10.2816 10.9825 9.67902 10.9998 9.07708C11.0284 8.08979 11.6972 7.36819 12.6633 7.25651C13.5114 7.15834 14.3534 7.72162 14.5879 8.56533C14.6475 8.77825 14.6655 9.00774 14.6679 9.23048C14.6772 10.0466 14.6605 10.8633 14.681 11.6794C14.6853 11.8395 14.774 12.0328 14.8882 12.1482C15.848 13.1183 16.8321 14.0651 17.7901 15.037C18.7189 15.9801 18.4161 17.5105 17.2118 17.9756C16.4877 18.2548 15.7928 18.1572 15.2301 17.6142C13.9755 16.4017 12.7427 15.1671 11.5061 13.9368C11.1369 13.5693 10.9961 13.1078 10.9961 12.5986C10.9961 12.0273 10.9961 11.4554 10.9961 10.8841H10.9973L10.9967 10.8835Z"
        fill="#E21F27"
      />
    </svg>
  );
};

const LockFund = () => {
  return (
    <svg
      width="27"
      height="21"
      viewBox="0 0 27 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_893_4011)">
        <path
          d="M24.5565 10.8976C25.5219 11.0578 26.0765 10.6203 26.0771 9.70116C26.0771 9.29829 26.0743 8.89488 26.0782 8.49202C26.0817 8.18327 26.2506 7.99725 26.5204 7.9934C26.7903 7.98954 26.9872 8.17832 26.9912 8.47276C26.998 8.98569 27.01 9.49917 26.986 10.0116C26.9404 10.9879 26.1142 11.765 25.102 11.803C24.8658 11.8118 24.6284 11.8041 24.4652 11.8041C24.1217 12.5355 23.8421 13.2471 23.465 13.9075C22.9098 14.8795 22.1806 15.7188 21.1781 16.3088C21.0936 16.3583 21.0343 16.4937 21.0177 16.5977C20.8603 17.574 20.7193 18.5531 20.5641 19.53C20.4785 20.0704 20.1151 20.3698 19.5508 20.3759C19.0002 20.3819 18.449 20.3819 17.8984 20.3759C17.3472 20.3698 16.9849 20.0804 16.889 19.5559C16.8165 19.1613 16.7715 18.7622 16.711 18.3385C14.545 18.9477 12.3882 19.0815 10.2023 18.421C10.1419 18.9857 10.074 19.5289 10.03 20.0732C10.0112 20.311 9.90335 20.3847 9.66827 20.383C8.76618 20.3753 7.86409 20.3737 6.96199 20.3836C6.7098 20.3864 6.61565 20.2955 6.58084 20.0567C6.42907 19.0055 6.26246 17.956 6.09014 16.9081C6.0736 16.8074 6.0017 16.6857 5.91611 16.6302C5.1076 16.1035 4.38752 15.4832 3.76787 14.7578C3.6412 14.6098 3.53336 14.5839 3.35819 14.6549C3.15791 14.7358 2.9468 14.7931 2.73854 14.8558C2.04927 15.0633 1.4222 14.7694 1.19054 14.1139C0.814529 13.0495 0.44308 11.9835 0.0847533 10.9136C-0.201109 10.06 0.265628 9.27243 1.1643 9.05394C1.46556 8.98074 1.84329 8.98019 2.04242 8.79912C2.23243 8.62631 2.21759 8.25537 2.32429 7.98294C2.55481 7.39406 2.80872 6.81343 3.0438 6.22565C3.08203 6.13043 3.102 6.01486 3.08488 5.91579C2.86064 4.6197 2.714 3.31921 2.89887 2.0077C2.95365 1.62135 3.06548 1.2383 3.19443 0.867364C3.33023 0.474959 3.65546 0.32361 4.07313 0.404513C5.39574 0.660429 6.53006 1.3005 7.61759 2.03137C7.77507 2.13704 7.8949 2.15575 8.07862 2.09246C10.5327 1.24546 13.0507 0.915245 15.6383 1.31425C18.5152 1.75784 20.9807 2.98624 22.8573 5.1497C24.2444 6.74904 24.7921 8.64777 24.5571 10.7375C24.5514 10.7903 24.5565 10.8448 24.5565 10.8976ZM5.50244 8.74849C5.94122 8.75179 6.30468 8.40451 6.29898 7.98789C6.29327 7.58008 5.94065 7.24436 5.51556 7.24161C5.07679 7.23886 4.71618 7.58448 4.72131 8.00275C4.72588 8.41442 5.07279 8.74518 5.50301 8.74849H5.50244Z"
          fill="#E21F27"
        />
      </g>
      <defs>
        <clipPath id="clip0_893_4011">
          <rect
            width="27"
            height="20"
            fill="white"
            transform="translate(0 0.383606)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
const Summery = () => {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.00823 18.1993C1.00823 18.0585 1.00823 17.9276 1.00823 17.7966C1.00823 12.7405 1.00823 7.68439 1.00823 2.62764C1.00883 1.22961 1.82046 0.384864 3.16548 0.384246C3.79735 0.384246 4.42922 0.383011 5.06109 0.384246C6.30169 0.387951 7.14952 1.25802 7.15248 2.5486C7.15782 4.96366 7.15426 7.37872 7.15426 9.79378C7.15426 12.4453 7.15426 15.0969 7.15426 17.7479V18.1727H8.43698V17.788C8.43698 14.4584 8.4352 11.1288 8.43817 7.79862C8.43876 6.75257 9.02317 5.94549 9.94931 5.70837C10.1101 5.667 10.281 5.65465 10.4477 5.65341C11.1585 5.64786 11.8698 5.64662 12.5806 5.65218C13.734 5.66082 14.5812 6.53891 14.583 7.73811C14.5866 11.0881 14.5842 14.4387 14.5842 17.7886C14.5842 17.9096 14.5842 18.0313 14.5842 18.1708H15.8806C15.8806 18.0535 15.8806 17.935 15.8806 17.8158C15.8806 15.7502 15.88 13.6847 15.8806 11.6185C15.8812 10.2816 16.7029 9.43069 17.9939 9.4276C18.6554 9.42637 19.317 9.42451 19.9785 9.4276C21.18 9.43501 22.0201 10.3082 22.0242 11.571C22.0308 13.647 22.026 15.7231 22.026 17.7985C22.026 17.9189 22.026 18.0387 22.026 18.1542C22.2426 18.1881 22.43 18.1993 22.6068 18.2499C22.8762 18.3277 23.0228 18.5765 22.9967 18.8618C22.9711 19.1372 22.7694 19.3435 22.49 19.3731C22.3921 19.3836 22.293 19.3805 22.1939 19.3805C15.0648 19.3805 7.93564 19.3805 0.806509 19.3805C0.697934 19.3805 0.588173 19.3836 0.481379 19.37C0.207866 19.3342 0.0138555 19.1138 0.000802858 18.8341C-0.0134364 18.5358 0.162775 18.2857 0.446374 18.2363C0.619618 18.206 0.798203 18.2104 1.00823 18.1974V18.1993Z"
        fill="#E21F27"
      />
    </svg>
  );
};
const SafeLock = () => {
  return (
    <Fade bottom>
      <div className="md:py-[4.6rem] py-[2rem] lg:px-[64px] px-[1rem] bg-[#F6F6F694] ">
        <div className="lg:flex gap-[60px] max-w-[1520px] mx-auto flex-col-reverse lg:flex-row ">
          <div className="flex-1">
            <div>
              <h1 className="text-[39px] font-extrabold text-[#1E1E1E] md:leading-[52px] leading-10">
                Safe lock
              </h1>
              <p className="text-[20px] md:my-[40px] my-10">
                Need more discipline with saving? This is for you. Save for long
                or short term goals and access funds when mature. 
              </p>
              <ul className="">
                <li className="flexx flexx-span md:mb-[20px] mb-10">
                  <EarnReturn /> Earn higher returns
                </li>
                <li className="flexx flexx-span md:mb-[20px] mb-10">
                  <Automate /> Automate savings
                </li>
                <li className="flexx flexx-span md:mb-[20px] mb-10">
                  <LockFund /> Lock funds for up to 1000 days
                </li>
                <li className="flexx flexx-span md:mb-[20px] mb-10">
                  <Summery /> Track Progress
                </li>
              </ul>
            </div>
          </div>
          <div className="flex-1">
            <div className="max-w-[572px] mx-auto max-h-[459px]">
              <img
                src="/images/safelock.png"
                alt="safelock"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default SafeLock;
